import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AppService} from '../../app.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-author',
  templateUrl: './author.component.html',
  styleUrls: ['./author.component.scss']
})
export class AuthorComponent implements OnInit {

  appId: number;
  appIdChange: number;
  redirectionMethod: string;
  authorData: any;
  authorDesc: any;

  constructor(
    private _route: ActivatedRoute,
    private _appService: AppService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.appId = this._route.snapshot.params.appid;

    this._route.params.forEach((params: any) => {
      console.log(params['appid']);
      const redirection = params['redirection'];
      if (redirection !== '') {
        this.redirectionMethod = redirection;
      } else {
        this.redirectionMethod = '';
      }
    });

    this._appService.getAuthorData(this.appId).subscribe(res => {
      console.log(res);
      this.authorData = res;
      if (res['dev_desc'] != null) {
        this.authorDesc = this.sanitizer.bypassSecurityTrustHtml(res['dev_desc']);
      }
    });
  }

}
